import {
  Sparkles,
  MessageCircle,
  Instagram,
  Send,
  Video,
  Youtube,
  Mail,
  Heart,
  Link as LinkIcon,
} from "lucide-react";

const ICONS = { Sparkles, MessageCircle, Instagram, Send, Video, Youtube, Mail, Heart, Link: LinkIcon };

export const LinkIconFor = ({ name, className }) => {
  const Icon = ICONS[name] || LinkIcon;
  return <Icon className={className} strokeWidth={1.75} aria-hidden="true" />;
};
